<template>
  <div
    :class="[
      'asc-caption',
      alwaysDisplayLabel ? 'asc-caption--always-display-label' : '',
    ]"
  >
    <template v-if="!isDisabledEmptyCaption">
      <asc-link-button
        v-if="!showCaption"
        text="Add Caption"
        :disabled="disabled"
        @click="handleShowCaption"
      ></asc-link-button>
      <asc-text-area-input
        v-if="showCaption"
        :value="caption"
        label="Caption"
        :disabled="disabled"
        :max-length="maxLength"
        hide-details
        @blur="handleBlur"
      ></asc-text-area-input>
    </template>
  </div>
</template>

<script>
import AscLinkButton from '@/components/atoms/AscLinkButton'
import AscTextAreaInput from '@/components/atoms/AscTextareaInput'

export default {
  name: 'AscCaption',

  components: {
    AscLinkButton,
    AscTextAreaInput,
  },

  props: {
    caption: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: null,
    },
    alwaysDisplayLabel: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showCaption: false,
    }
  },

  computed: {
    isDisabledEmptyCaption() {
      return this.disabled && this.caption === ''
    },
  },

  watch: {
    caption(newValue) {
      this.showCaption = newValue !== null && newValue.length > 0
    },
  },

  mounted() {
    this.showCaption = this.caption !== null && this.caption.length > 0
  },

  methods: {
    handleShowCaption() {
      this.showCaption = true
    },

    handleBlur(value) {
      if (value === '' || value === null) {
        this.showCaption = false
      }
      this.$emit('blur', value)
    },
  },
}
</script>

<style lang="scss">
.asc-caption {
  margin: 0;

  .v-label--active {
    display: none;
  }

  .v-input__slot {
    margin-bottom: 0;
  }

  .asc-link-button--label {
    margin: 16px 0 0 8px;
  }
}

.asc-caption--always-display-label {
  .v-label--active {
    display: inherit !important;
  }
}
</style>
